var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCropxWhiteX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 25,
    viewBox: "0 0 36 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.55957 24.7435H7.50334L15.7389 15.0943L11.3905 5.9812L6.08697 5.9813L10.6997 15.1732L2.55957 24.7435Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7513 14.1501L14.9629 10.5141L18.555 5.9812H23.7701L16.7513 14.1501Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.546 16.4346L20.4933 24.7436H15.5331L13.2559 20.2396L16.546 16.4346Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3321 0.72785C33.5572 6.16995 32.2579 6.74948 25.6235 5.24527C26.8106 -0.0527663 28.3371 -0.78746 35.3321 0.72785Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCropxWhiteX);
export default __webpack_public_path__ + "static/media/cropx_white_x.b641bf59153309c3fb80fa086e25eb4f.svg";
export { ForwardRef as ReactComponent };